module.exports = __webpack_public_path__ + "static/media/quinoa.cb04ea17.jpg";